import { Component, OnInit, Inject, PLATFORM_ID } from '@angular/core';
declare var $: any;
import * as $ from 'jquery';
import * as AOS from 'aos';
import { WINDOW } from '@ng-toolkit/universal';
import { isPlatformBrowser } from '@angular/common';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
})
export class HeaderComponent implements OnInit {

  constructor(
    @Inject(WINDOW) private window: Window,
    @Inject(PLATFORM_ID) private platformId: Object
  ) { }

  ngOnInit() {
    if (isPlatformBrowser(this.platformId)) {

      $("#apiGrammarChecker").click(function (){
        $("#enterpriseMainMenu").removeClass('active');
      });

      $(window).scroll(function () {
        if ($(window).scrollTop() >= 100) {
          $('#main_header').addClass('sticky');
        }
        else {
          $('#main_header').removeClass('sticky');
        }
      });

      $("#main_sub_menus").hover(
        function () {
          // $(".dropdown").addClass("open");
          $("#Home_sub_menus").addClass("show");
        }, function () {
          // $(".dropdown").removeClass("open");
          $("#Home_sub_menus").removeClass("show");
        }
      );
      $("#enterprise_main_sub_menus").hover(
        function () {
          // $(".dropdown").addClass("open");
          $("#enterprise_sub_menus").addClass("show");
        }, function () {
          // $(".dropdown").removeClass("open");
          $("#enterprise_sub_menus").removeClass("show");
        }
      );
      $("#feature_main_sub_menus").hover(
        function () {
          // $(".dropdown").addClass("open");
          $("#feature_sub_menus").addClass("show");
        }, function () {
          // $(".dropdown").removeClass("open");
          $("#feature_sub_menus").removeClass("show");
        }
      );
      $("#resources_main_sub_menus").hover(
        function () {
          // $(".dropdown").addClass("open");
          $("#resources_sub_menus").addClass("show");
        }, function () {
          // $(".dropdown").removeClass("open");
          $("#resources_sub_menus").removeClass("show");
        }
      );
      $(this.window).resize(function () {
        if ($(this.window).width() < 1199) {
          $('.nav-item').click(function () {
            $('#mobile_menu_toggle').click();
          });
          $(".nav-item.dropdown").unbind("click");
          $(".nav-item.dropdown > .dropdown-menu > .nav-link").click(function () {
            $('#mobile_menu_toggle').click();
          });
        }
      });

      $(document).ready(function () {
        if ($(this.window).width() < 1199) {
          $('.nav-item').click(function () {
            $('#mobile_menu_toggle').click();
          });
          $(".nav-item.dropdown").unbind("click");
          $(".nav-item.dropdown > .dropdown-menu > .nav-link").click(function () {
            $('#mobile_menu_toggle').click();
          });
        }
      });

      // Body overlay Jquery. Click any where menu will be closed
      $("#mobile_menu_toggle").click(function () {
        $("#body_overlay_section").toggleClass("body_overlay");
      });

      $("#body_overlay_section").click(function () {
        $("#mobile_menu_toggle").click();
        $("#body_overlay_section").hasClass("body_overlay").removeClass("body_overlay");
      });

      $(document).click(function (event) {
        var clickover = $(event.target);
        var _opened = $(".navbar-collapse").hasClass("show");
        if (_opened === true && !clickover.hasClass("navbar-toggle")) {
            $("button.navbar-toggler").click();
        }
      });

      // AOS animation
      AOS.init();
    }
  }
}
